import { LoadableLazy } from '@confluence/loadable';

export const ApprovalBanner = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ApprovalBanner" */ '../src/BannerComponent/ApprovalBanner.tsx'
			)
		).ApprovalBanner,
});
